@if (!hasWarehousePermission()) {
    <app-no-permission />
} @else {
    <section class="flex flex-col h-full gap-7">
        <app-management-main-panel-title
            [icon]="['fas', 'database']"
            [title]="title()">
            @if (!managementDataService.isEmptyWarehouse()) {
                <div class="flex flex-row justify-center items-center gap-6 mr-7">
                    @if (viewType() === DataViewType.ORGANIZATION_DATA) {
                        <app-button
                            [icon]="['fas', 'arrow-down-to-line']"
                            [label]="'export' | transloco"
                            [loading]="exportService.depositExportStatus() === ExportStatusEnum.IN_PROGRESS"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="openExportDepositModal()" />

                        <app-button
                            [disabled]="!managementDataService.canManageDeposit()"
                            [icon]="['fas', 'plus']"
                            [label]="'addData' | transloco"
                            [matTooltip]="
                                managementDataService.canManageDeposit() ? '' : ('insufficientPermissions' | transloco)
                            "
                            [type]="ButtonType.PRIMARY"
                            (onClick)="openAddDataModal()" />
                    }
                </div>
            }
        </app-management-main-panel-title>

        <div class="flex flex-col gap-1 flex-1 min-h-0">
            <section class="flex min-h-0 flex-col m-2.5 grow">
                @if (managementDataService.isEmptyWarehouse()) {
                    <div class="w-full h-full grow flex flex-col items-center justify-center gap-3">
                        <app-no-data-to-display
                            iconSize="5x"
                            [displayedMessage]="'noDataFound'" />

                        <app-button
                            [disabled]="!managementDataService.canManageDeposit()"
                            [icon]="['fas', 'plus']"
                            [label]="'addData' | transloco"
                            [matTooltip]="
                                managementDataService.canManageDeposit() ? '' : ('insufficientPermissions' | transloco)
                            "
                            [type]="ButtonType.PRIMARY"
                            (onClick)="openAddDataModal()" />
                    </div>
                } @else {
                    @if (organizationStorage(); as storage) {
                        <app-organization-storage-usage
                            class="w-[30rem]"
                            [organizationStorage]="storage" />
                    }
                    <app-management-list-header
                        [asAction]="false"
                        [searchValue]="managementDataService.searchValue()"
                        [title]="'data' | transloco"
                        (search)="managementDataService.onSearchDepositFolder($event)" />
                    @if (managementDataService.dataColumn()) {
                        <app-custom-table
                            class="m-2 flex-1 min-h-0 overflow-auto deposit-folder-table-format"
                            [columns]="managementDataService.customColumns()"
                            [isSelectable]="false"
                            [translateColumns]="true"
                            (sortEvent)="managementDataService.onSortChange($event)">
                            @for (depositFolder of managementDataService.dataColumn(); track depositFolder.id) {
                                <tr (click)="managementDataService.toggleExpandedElement(depositFolder.id)">
                                    @for (column of managementDataService.customColumns(); track column.key) {
                                        <td>
                                            <app-deposit-row-item
                                                [column]="column"
                                                [depositFolder]="depositFolder" />
                                        </td>
                                    }
                                </tr>

                                <tr
                                    class="deposit-list-table"
                                    [hidden]="managementDataService.expandedElementId() !== depositFolder.id">
                                    <td [attr.colspan]="managementDataService.customColumns().length">
                                        <div class="flex justify-center w-full">
                                            <mat-divider class="w-4/5" />
                                        </div>
                                        @if (managementDataService.expandedElementId() === depositFolder.id) {
                                            <div
                                                animate.enter="enter-animation"
                                                class="mt-4">
                                                <app-deposit-list
                                                    [depositFolder]="
                                                        managementDataService.findDepositFolder(depositFolder)
                                                    " />
                                            </div>
                                        }
                                    </td>
                                </tr>
                            } @empty {
                                <tr>
                                    <td
                                        class="text-center py-4"
                                        [attr.colspan]="managementDataService.customColumns().length">
                                        <app-no-data-to-display
                                            [displayedMessage]="'noDataFound'"
                                            [iconSize]="'5x'" />
                                    </td>
                                </tr>
                            }
                        </app-custom-table>
                    }
                }
                <div class="flex justify-between items-center mx-4">
                    <app-paginator
                        #paginator
                        [take]="managementDataService.pagination().take"
                        [totalItems]="managementDataService.pagination().totalItems ?? 0"
                        (onPageChange)="managementDataService.onPaginationChange($event)" />
                    <span class="text-on-surface"
                        >{{ DepositFolderListBloc.value()!.totalItems }}
                        {{ 'data' | transloco: { value: DepositFolderListBloc.value()!.totalItems } }}</span
                    >
                </div>
            </section>
        </div>
    </section>
}
